export function convertByteToMB(bytes) {
  if (!bytes) return null;

  return `${(parseInt(bytes, 10) / 1000000).toFixed(2)} MB`;
}



// WEBPACK FOOTER //
// ./app/lib/bytes.js